import React from 'react';
import { Create } from 'react-admin';
import PaisForm from '../PaisForm';

function PaisCreate(props) {
  return (
    <Create {...props}>
      <PaisForm redirect="list" mode="create" />
    </Create>
  );
}

export default PaisCreate;
